export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const toggleSidebar = () => {
  return {
    type: TOGGLE_SIDEBAR,
  };
};
